import '../styles/globals.css'
import { AlertProvider } from '../components/warning/AlertProvider'
import GoogleTagManager from '../components/GoogleTagManager'
import MetaPixel from '../components/MetaPixel'
import { useEffect } from 'react'
import { initializeAppInsights } from '../app-insights'
import { MsalProvider } from '@azure/msal-react'
import { PublicClientApplication } from '@azure/msal-browser'
import { msalConfig } from '../constants/ms-auth'

// MSAL must only be instantiated in the browser. MsalProvider handles
// initialization internally and exposes the startup state via useMsal().
const msalInstance =
  typeof window !== 'undefined'
    ? new PublicClientApplication(msalConfig)
    : null

function MyApp({ Component, pageProps }) {
  useEffect(() => {
    initializeAppInsights({
      cloudRoleName: 'EHG-Website',
      cloudRoleInstance: process.env.NODE_ENV || 'production'
    });
  }, []);

  const content = (
    <AlertProvider>
      <GoogleTagManager />
      <MetaPixel />
      <Component {...pageProps} />
    </AlertProvider>
  )

  if (!msalInstance) {
    return content
  }

  return <MsalProvider instance={msalInstance}>{content}</MsalProvider>
}

export default MyApp